import { endPoints, requestType } from "../lib/variable";
import Api from "./index";

const userUpdate = (id, payload) => {
  return Api(`${endPoints.userUpdate}/${id}`, payload, requestType.PUT);
};
const userDetails = (id) => {
  return Api(`${endPoints.userDetails}/${id}`, requestType.GET);
};

const getAllHomedata = () => {
  return Api(`${endPoints.fetchHomedata}?type=web`, null, requestType.GET);
};

const getAllTips = () => {
  return Api(endPoints.getTips, null, requestType.GET);
};
export { userUpdate, userDetails, getAllHomedata, getAllTips };
